var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout',{attrs:{"name":"Builder"}},[_c('div',{ref:"reactRoot",attrs:{"id":"root"}},[_c('WithLoader',{attrs:{"isLoading":_vm.builderIsLoading}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }